//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { searchFilterUpdates } from '@search-filters/constants/searchFilterUpdates';

(function() {
  const curalate = angular.module('curalate');

  curalate.constant('SearchFilterUpdates', searchFilterUpdates);
})();
